import React from "react";
import { Col, OverlayTrigger, Tooltip } from "react-bootstrap";

const DashboardItem = ({ children, style, popoverContent }) => {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={(props) =>
        popoverContent ? (
          <Tooltip
            className="mytooltip"
            style={{ padding: 8, width: 600 }}
            {...props}
          >
            {popoverContent}
          </Tooltip>
        ) : (
          <div></div>
        )
      }
    >
      <Col xs="6" sm="4" md="3" style={style ?? { marginBottom: "32px" }}>
        {children}
      </Col>
    </OverlayTrigger>
  );
};

export default DashboardItem;
